import angular from 'angular';

(function() {
    'use strict';
    angular.module('indexfile').factory('IndexFile', IndexFileData);

    IndexFileData.$inject = ['logger', '$translate'];

    /* @ngInject */
    function IndexFileData(logger, $translate) {
        IndexFile.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            getStatusLabel: getStatusLabel
        };

        function IndexFile(indexFileData) {
            if (!indexFileData) {
                this.buildEmpty();
            } else {
                this.build(indexFileData);
            }
        }

        return IndexFile;

        /////////////////////

        function buildEmpty() {
            this.id = null;
            this.receptionDate = null;
            this.ladProviderId = null;
            this.ladProviderName = null;
            this.status = null;
            this.reference = null;
        }

        function build(indexFileData) {
            this.id = indexFileData.id || null;
            this.receptionDate = indexFileData.receptionDate || null;
            this.ladProviderId = indexFileData.ladProviderId || null;
            this.ladProviderName = indexFileData.ladProviderName || null;
            this.status = indexFileData.status || null;
            this.reference = indexFileData.filename || null;
        }

        function getStatusLabel() {
            if (this.status) {
                return $translate.instant('dashboard.column.indexfile.status.' + this.status);
            }
            return '';
        }
    }
})();
